/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";


    class SignOutRedirectCallBack {
        static controllerId: string = "signOutRedirectCallBack";
        static $inject: Array<string> = ["$window", "common", "config"];
        message: string;

        constructor(private $window: ng.IWindowService, private common: ICommonFactory, private config: IConfig) {
            this.message = "Signing Out...";
            common.authentication.completeLogout().then(user => {
                if (this.$window.location != this.$window.parent.location) {
                    this.$window.parent.postMessage("Cfnc", "*");
                    this.message = "Signed Out";
                } else {
                    $window.location.href = config.umbracoUrl;
                }
            });
        }
    }
    angular.module("app").controller(SignOutRedirectCallBack.controllerId, SignOutRedirectCallBack);
}